export default __webpack_public_path__ + "static/media/Full-logo-WHITE.8c03b4b5.svg";